const aliases = {
  fire: "fire", smoke: "fire",
  shoplifting: "theft", theft: "theft", robbery: "theft",
  fall: "fall", person_fall: "fall",
  intrusion: "intrusion", restricted_area: "intrusion", trespassing: "intrusion",
  queue: "crowd", crowd: "crowd", overcrowding: "crowd", crowding: "crowd",
  person: "person", people: "person", counter: "person", person_count: "person", people_count: "person",
  vehicle: "vehicle", car: "vehicle", weapon: "weapon", gun: "weapon",
  dwell: "dwell", loitering: "dwell", heatmap: "heatmap",
};

export const getAlertCategory = (detectionType) => {
  const key = String(detectionType || "").trim().toLowerCase().replace(/[ -]+/g, "_").replace(/_detection$/, "");
  return aliases[key] || "other";
};

export const getConfidencePercent = (value) => {
  if (!["number", "string"].includes(typeof value) || String(value).trim() === "") return null;
  const number = Number(value);
  if (!Number.isFinite(number) || number < 0 || number > 100) return null;
  return Math.round(number <= 1 ? number * 100 : number);
};
